import React, {useEffect, useState} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputMoney from "../components/Form/UiInputMoney";
import {get} from "../services/ApiService";
import UiInputNumberPercentage from "../components/Form/UiInputNumberPercentage";
import UiGridFormTable from "../components/Form/UiGridFormTable";
import {Util} from "../util/Util";

const doFetchCusto = (contratoId, custoList, setValue) => {
    get(`/?route=contrato/form&action=getCustos&rows=${JSON.stringify([{
        id: contratoId,
        custoList: custoList
    }])}`)
        .then((response) => {
            if (response.status == 200) {
                const data = response.data;
                setValue(data);
            } else {
                alert('Falha ao carregar o consumo');
            }
        })
        .catch((err) => {
            alert('Falha ao carregar o consumo: ' + err);
        })
}

const CustosLinkComponent = (props) => {
    const { watch, getValues, setValue } = props.formContext;
    const [ isLoading, setIsLoading ] = useState(false);

    const allData = watch();
    let contratoId = allData?.id;

    const base = props.name;
    const consumoData = getValues(base);

    return <>
        {
            <button type="button" onClick={() => {
                if(window.confirm("Isso vai sobrescrever todos os custos da tabela, continuar?")) {
                    setIsLoading(true);
                    doFetchCusto(contratoId, consumoData, (res) => {
                        setIsLoading(false);
                        setValue('calculoCusto', res?.payload);
                        setValue(base, res?.payload?.custos);
                    })
                }
            }} className="btn btn-primary btn-xs">{ isLoading ? `Carregando...` : `Montar baseado no orçamento` }</button>
        }
    </>
}

export default function ContratoFinanceiroForm(props){

    let defaultValues = props.data;

    const methods = useForm({
        defaultValues: defaultValues,
        shouldUnregister: false
    });
    const { handleSubmit, watch, setValue, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const allData = watch();

    const calcularCusto = () => {
        let custoList = allData.custoList;
        let precoVenda = allData.precoVenda;
        let maoDeObra = allData.precoMaoObra;
        const custoTotal = custoList.reduce((n, { value }) => n + value, 0);

        const sobraEmpresa = (precoVenda - custoTotal);
        const lucroLiquido = ((sobraEmpresa / precoVenda)*100);

        setValue('calculoCusto', {
            valorBase: precoVenda,
            maoDeObra: maoDeObra,
            lucroLiquido: lucroLiquido.toFixed(2) * 1,
            custoTotal: custoTotal.toFixed(2) * 1,
            sobraEmpresa: sobraEmpresa.toFixed(2) * 1
        });
    }

    const custoColor = (allData?.calculoCusto?.lucroLiquido < 10)?(allData?.calculoCusto?.lucroLiquido<5)?'#C00':'#009':'#090'

    return (
        <>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <WindowBody>
                        { allData?.calculoCusto?.sobraEmpresa && <div className="margemLucro">
                            Margem: <b>{Util.moeda(allData.calculoCusto.sobraEmpresa)}</b> - <b style={{color: custoColor}}>{allData.calculoCusto.lucroLiquido}%</b>
                        </div> }
                        <button type="button" onClick={calcularCusto} className="btn btn-primary btn-xs mt-2">Recalcular</button>

                        <UiGridFormTable name="custoList" label="Custos" linkComponent={CustosLinkComponent}>
                            <UiInputText asTable={true} size={8} name="title" label="Descrição"/>
                            <UiInputMoney asTable={true} size={2} name="value" label="Valor"/>
                            <UiInputNumberPercentage asTable={true} size={2} minFractionDigits={2} maxFractionDigits={2} name="percent" label="%" inputClassName="text-right"/>
                        </UiGridFormTable>
                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}
